import React, { useCallback, useEffect, useState } from 'react';
import { FaSync, FaCamera } from 'react-icons/fa';
import { fetchLatestCameraSnapshot } from './cameraApi';

const CameraSnapshot = ({ motor, user }) => {
  const [snapshot, setSnapshot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [imageFailed, setImageFailed] = useState(false);

  const loadSnapshot = useCallback(async () => {
    setLoading(true);
    setError('');
    setImageFailed(false);
    try {
      const data = await fetchLatestCameraSnapshot(motor.id, user.token);
      setSnapshot(data);
      if (!data) {
        setError("Aucune image disponible pour ce compteur.");
      }
    } catch (err) {
      console.error('Erreur lors de la récupération du dernier relevé image :', err);
      setError("Impossible de charger l'image du compteur.");
    } finally {
      setLoading(false);
    }
  }, [motor.id, user.token]);

  useEffect(() => {
    if (motor.id) loadSnapshot();
  }, [motor.id, loadSnapshot]);

  return (
    <div className="bg-white border border-gray-200 shadow-lg rounded-lg p-6 sm:p-8 mb-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-400 to-orange-400 flex items-center justify-center shrink-0">
            <FaCamera className="text-white text-sm" />
          </div>
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">Dernier relevé caméra</h2>
        </div>
        <button
          onClick={loadSnapshot}
          disabled={loading}
          className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 font-medium transition-colors disabled:opacity-50"
        >
          <FaSync className={loading ? 'animate-spin' : ''} />
          Actualiser
        </button>
      </div>

      {loading ? (
        <div className="bg-gray-100 rounded-xl h-64 flex items-center justify-center">
          <p className="text-gray-400 text-sm">Chargement de l'image...</p>
        </div>
      ) : error || imageFailed ? (
        <div className="bg-gray-50 rounded-xl h-64 flex items-center justify-center text-center px-4">
          <p className="text-gray-400 text-sm">
            {imageFailed ? "L'image n'a pas pu être chargée." : error}
          </p>
        </div>
      ) : snapshot ? (
        <div className="space-y-4">
          <div className="rounded-xl overflow-hidden border border-gray-200 bg-black">
            <img
              src={snapshot.presignedUrl}
              alt="Dernier relevé du compteur"
              className="w-full h-auto max-h-[500px] object-contain mx-auto"
              onError={() => setImageFailed(true)}
            />
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 bg-gray-50 rounded-xl px-5 py-4">
            <div>
              <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Relevé</p>
              <p className="text-lg font-semibold text-gray-800">{snapshot.compteur} m³</p>
            </div>
            <div className="sm:text-right">
              <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Date</p>
              <p className="text-sm text-gray-700">
                {new Date(snapshot.timestamp).toLocaleString('fr-FR', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CameraSnapshot;